import { useMutation } from 'react-query';

import { makeFetchCustomerByIdUseCase } from 'modules/checkin/domain/useCases';
import { useActiveCustomer } from 'shared/presentation/contexts';

type TParams = {
  onError?: (error: unknown) => void;
};

export default function useFindCustomerById(params: TParams = {}) {
  const { setCustomer, setIdentifiedByBiometry } = useActiveCustomer();

  const mutation = useMutation(
    (id: number) => makeFetchCustomerByIdUseCase().execute({ id }),
    {
      onSuccess: customer => {
        setCustomer(customer);
        setIdentifiedByBiometry(true);
      },
      onError: params.onError,
    },
  );

  return {
    loading: mutation.isLoading,
    find: mutation.mutateAsync,
  };
}
